import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {OTPublisher} from 'opentok-react';
import {removeAllModalPopUps, vuePayLog} from "../../util/utility";
import {endOTSessionCountdown, startOTSessionCountdown} from "../../util/broadcast/start_broadcast";

//more details https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
const propTypes = {
    audio: PropTypes.bool,
    video: PropTypes.bool,
    shareScreen: PropTypes.bool,
    onInit: PropTypes.func,
    onPublish: PropTypes.func,
    onError: PropTypes.func,
};

class Publisher extends Component {

    constructor(props) {
        super(props);
        this.publisherRef = React.createRef();
        this.publisherEventHandlers = {
            mediaStopped: event => {
                vuePayLog("Publisher","constructor >> mediaStopped",event)
            },
            streamCreated: event => {
                vuePayLog("Publisher","constructor >> streamCreated",event)
                // if (this.props.isCountdownRequired) {
                //     startOTSessionCountdown((time) => {
                //         this.props.setElapsedTime(time)
                //     })
                // }
            },
            streamDestroyed: event => {
                vuePayLog("Publisher","constructor >> streamDestroyed",event)
                this.props.toggleEndSessionModal()
                //endOTSessionCountdown();
                removeAllModalPopUps()
                // navigate(this.props,"broadcaster_create_broadcast");
                //event.stream.videoType == "screen" && this.props.toggleScreenShare()
            }
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const element = document.getElementsByClassName("OTPublisherContainer")[0]
        if (element) {
            element.style.height = nextProps.height;

        }

    }

    render() {
        const {audio, video, shareScreen, videoSource, audioSource, videoSourceIndex, audioSourceIndex, onInit, onPublish, onError, width,height} = this.props;
        return (
            <div id={"pub-id"}>
                <OTPublisher
                    ref={this.publisherRef}
                    session={this.props.session}
                    properties={{
                        audioBitrate: 64000,
                        disableAudioProcessing: true,
                        enableStereo: true,
                        frameRate: 30,
                        videoSource: videoSource,
                        audioSource: shareScreen ? audioSource : undefined,
                        publishAudio: audio,
                        publishVideo: video,
                        showControls: false,
                        audioFallbackEnabled: false,
                        mirror: !shareScreen,
                        // width: width,
                        // height: height,
                        fitMode: 'cover',
                        resolution: "1280x720",
                    }}
                    eventHandlers={this.publisherEventHandlers}
                    onInit={() => {
                        this.props.onInit(this.publisherRef);
                        if (this.props.setOTSession) {
                            this.props.setOTSession(this.props.session);
                        }
                    }}
                    onPublish={onPublish}
                    onError={onError}
                />
            </div>
        );
    }
}

Publisher.propTypes = propTypes;
export default Publisher;